import React from "react";

const CompleteProfile = ({
  width = 36,
  height = 50,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.205078"
        y="0.550781"
        width="38.1628"
        height="45.1034"
        rx="7.51724"
        fill="#133345"
      />
      <path
        d="M18.0141 17.7734C17.7534 17.7734 17.5371 17.9864 17.5371 18.2433V19.1829C17.5371 19.4398 17.7534 19.6527 18.0141 19.6527C18.2749 19.6527 18.4912 19.4398 18.4912 19.1829V18.2433C18.4912 17.9864 18.2749 17.7734 18.0141 17.7734Z"
        fill="#E0DEF7"
      />
      <path
        d="M25.6452 21.3777H25.0092V14.3177C25.0092 13.9293 24.8311 13.566 24.5194 13.328L20.0671 9.92015C19.6092 9.56308 18.9604 9.56308 18.5024 9.92015L14.0501 13.328C13.7384 13.566 13.5603 13.9293 13.5603 14.3115L13.5285 21.3777H12.9243C12.6635 21.3777 12.4473 21.5844 12.4473 21.8475C12.4473 22.1043 12.6635 22.3173 12.9243 22.3173H25.6452C25.906 22.3173 26.1223 22.1043 26.1223 21.8475C26.1223 21.5844 25.906 21.3777 25.6452 21.3777ZM18.3307 12.2943H20.2388C20.4996 12.2943 20.7159 12.5073 20.7159 12.7642C20.7159 13.021 20.4996 13.234 20.2388 13.234H18.3307C18.0699 13.234 17.8537 13.021 17.8537 12.7642C17.8537 12.5073 18.0699 12.2943 18.3307 12.2943ZM22.465 21.3777H16.1045V15.8964C16.1045 15.3764 16.5307 14.9567 17.0586 14.9567H21.5109C22.0388 14.9567 22.465 15.3764 22.465 15.8964V21.3777Z"
        fill="#E0DEF7"
      />
      <path
        d="M7.83984 30.6211H24.7536"
        stroke="#E0DEF7"
        strokeWidth="1.87931"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M7.83984 36.2578H17.2364"
        stroke="#E0DEF7"
        strokeWidth="1.87931"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="30.7324"
        y="32.5"
        width="15.2651"
        height="16.9138"
        rx="2.81897"
        fill="#2D96A7"
      />
      <path
        d="M38.1652 44.478C40.2509 44.478 41.9417 42.8127 41.9417 40.7585C41.9417 38.7043 40.2509 37.0391 38.1652 37.0391C36.0795 37.0391 34.3887 38.7043 34.3887 40.7585C34.3887 42.8127 36.0795 44.478 38.1652 44.478Z"
        stroke="white"
        strokeWidth="1.40948"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.34 44.869L41.5449 44.0859"
        stroke="white"
        strokeWidth="1.40948"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CompleteProfile;
